export default {
    text: {
        main: {
            message: 'Pick a number',
        },
    },
};
